var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-wrapper"},[_c('Editor',{attrs:{"init":_vm.tinyInit,"api-key":_vm.apiKey},on:{"input":_vm.onChange},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }